import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { EventEmitter } from 'events';
import Vue from 'vue';
var API_URL = 'https://www.recaptcha.net/recaptcha/api.js';
var ReCaptcha = /*#__PURE__*/function () {
  function ReCaptcha(_ref) {
    var hideBadge = _ref.hideBadge,
      language = _ref.language,
      mode = _ref.mode,
      siteKey = _ref.siteKey,
      version = _ref.version,
      size = _ref.size;
    _classCallCheck(this, ReCaptcha);
    if (!siteKey) {
      throw new Error('ReCaptcha error: No key provided');
    }
    if (!version) {
      throw new Error('ReCaptcha error: No version provided');
    }
    this._elements = {};
    this._grecaptcha = null;
    this._eventBus = null;
    this._ready = false;
    this.hideBadge = hideBadge;
    this.language = language;
    this.siteKey = siteKey;
    this.version = version;
    this.size = size;
    this.mode = mode;
  }
  return _createClass(ReCaptcha, [{
    key: "destroy",
    value: function destroy() {
      if (this._ready) {
        this._ready = false;
        var _document = document,
          head = _document.head;
        var style = this._elements.style;
        var scripts = _toConsumableArray(document.head.querySelectorAll('script')).filter(function (script) {
          return script.src.includes('recaptcha');
        });
        if (scripts.length) {
          scripts.forEach(function (script) {
            return head.removeChild(script);
          });
        }
        if (head.contains(style)) {
          head.removeChild(style);
        }
        var badge = document.querySelector('.grecaptcha-badge');
        if (badge) {
          badge.remove();
        }
      }
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.init();
            case 3:
              if (!('grecaptcha' in window)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", this._grecaptcha.execute(this.siteKey, {
                action: action
              }));
            case 5:
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              throw new Error("ReCaptcha error: Failed to execute ".concat(_context.t0));
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7]]);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "getResponse",
    value: function getResponse(widgetId) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        if ('grecaptcha' in window) {
          if (_this.size == 'invisible') {
            _this._grecaptcha.execute(widgetId);
            window.recaptchaSuccessCallback = function (token) {
              _this._eventBus.emit('recaptcha-success', token);
              resolve(token);
            };
            window.recaptchaErrorCallback = function (error) {
              _this._eventBus.emit('recaptcha-error', error);
              reject(error);
            };
          } else {
            var response = _this._grecaptcha.getResponse(widgetId);
            if (response) {
              _this._eventBus.emit('recaptcha-success', response);
              resolve(response);
            } else {
              var errorMessage = 'Failed to execute';
              _this._eventBus.emit('recaptcha-error', errorMessage);
              reject(errorMessage);
            }
          }
        }
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      if (this._ready) {
        // make sure caller waits until recaptcha get ready
        return this._ready;
      }
      this._eventBus = new EventEmitter();
      this._elements = {
        script: document.createElement('script'),
        style: document.createElement('style')
      };
      var _this$_elements = this._elements,
        script = _this$_elements.script,
        style = _this$_elements.style;
      script.setAttribute('async', '');
      script.setAttribute('defer', '');
      var params = [];
      if (this.version === 3) {
        params.push('render=' + this.siteKey);
      }
      if (this.language) {
        params.push('hl=' + this.language);
      }
      var scriptUrl = API_URL;
      if (this.mode === 'enterprise') {
        scriptUrl = scriptUrl.replace('api.js', 'enterprise.js');
        params.push('render=' + this.siteKey);
      }
      script.setAttribute('src', scriptUrl + '?' + params.join('&'));
      window.recaptchaSuccessCallback = function (token) {
        return _this2._eventBus.emit('recaptcha-success', token);
      };
      window.recaptchaExpiredCallback = function () {
        return _this2._eventBus.emit('recaptcha-expired');
      };
      window.recaptchaErrorCallback = function () {
        return _this2._eventBus.emit('recaptcha-error', 'Failed to execute');
      };
      this._ready = new Promise(function (resolve, reject) {
        script.addEventListener('load', function () {
          if (_this2.version === 3 && _this2.hideBadge) {
            style.innerHTML = '.grecaptcha-badge { display: none }';
            document.head.appendChild(style);
          } else if (_this2.version === 2 && _this2.hideBadge) {
            // display: none DISABLES the spam checking!
            // ref: https://stackoverflow.com/questions/44543157/how-to-hide-the-google-invisible-recaptcha-badge
            style.innerHTML = '.grecaptcha-badge { visibility: hidden; }';
            document.head.appendChild(style);
          }
          _this2._grecaptcha = window.grecaptcha.enterprise || window.grecaptcha;
          _this2._grecaptcha.ready(resolve);
        });
        script.addEventListener('error', function () {
          document.head.removeChild(script);
          reject('ReCaptcha error: Failed to load script');
          _this2._ready = null;
        });
        document.head.appendChild(script);
      });
      return this._ready;
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      return this._eventBus.on(event, callback);
    }
  }, {
    key: "reset",
    value: function reset(widgetId) {
      if (this.version === 2 || typeof widgetId !== 'undefined') {
        this._grecaptcha.reset(widgetId);
      }
    }
  }, {
    key: "render",
    value: function render(reference, _ref2) {
      var sitekey = _ref2.sitekey,
        theme = _ref2.theme;
      return this._grecaptcha.render(reference.$el || reference, {
        sitekey: sitekey,
        theme: theme
      });
    }
  }]);
}();
export default function (_, inject) {
  var _ref3 = _.$config || {},
    _ref3$recaptcha = _ref3.recaptcha,
    recaptcha = _ref3$recaptcha === void 0 ? {} : _ref3$recaptcha;
  var options = _objectSpread(_objectSpread({}, {
    "hideBadge": true,
    "siteKey": "6LfN3fUjAAAAALgfcDgml7u3-97VCXb0FFulZQE8",
    "version": 3
  }), recaptcha);
  Vue.component('Recaptcha', function () {
    return import('./recaptcha.vue');
  });
  inject('recaptcha', new ReCaptcha(options));
}